/* Chrome flotante.

   Dos cosas:
     1. --mat: cuanto material tiene la barra. Sube con el scroll en vez de
        encenderse de golpe. Arriba del todo el vidrio casi no existe.
     2. --spec: el reflejo que sigue al puntero por el canto del vidrio.
        Solo con mouse: en un dedo no hay puntero que seguir. */
(function () {
  "use strict";

  var nav = document.getElementById("nav");
  if (!nav) { return; }
  var capsula = nav.querySelector(".nav-in");

  var pedido = false;
  function medir() {
    pedido = false;
    var m = window.scrollY / 120;
    if (m > 1) { m = 1; }
    nav.style.setProperty("--mat", m.toFixed(3));
  }
  function alScroll() { if (!pedido) { pedido = true; requestAnimationFrame(medir); } }
  medir();
  window.addEventListener("scroll", alScroll, { passive: true });

  if (!capsula) { return; }
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) { return; }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { return; }

  capsula.addEventListener("pointermove", function (e) {
    var r = capsula.getBoundingClientRect();
    capsula.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
    capsula.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
    capsula.style.setProperty("--spec", "1");
  });
  capsula.addEventListener("pointerleave", function () {
    capsula.style.setProperty("--spec", "0");
  });
})();
